import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

// material-ui
import { makeStyles, useTheme } from '@material-ui/styles';
import { Box, Button, Drawer, useMediaQuery, Chip } from '@material-ui/core';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// assets
import { IconLogout } from '@tabler/icons';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { drawerWidth } from 'store/constant';
import useAuth from 'hooks/useAuth';
import { useNavigate } from 'react-router';
import config from 'config';

// style constant
const useStyles = makeStyles((theme) => ({
    drawer: {
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            flexShrink: 0
        }
    },
    drawerPaper: {
        width: drawerWidth,
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
        borderRight: 'none',
        [theme.breakpoints.up('md')]: {
            top: '88px'
        }
    },
    ScrollHeight: {
        height: 'calc(100vh - 88px)',
        paddingLeft: '16px',
        paddingRight: '16px',
        [theme.breakpoints.down('sm')]: {
            height: 'calc(100vh - 56px)'
        }
    },
    boxContainer: {
        display: 'flex',
        padding: '16px',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    listItem: {
        marginTop: '5px'
    }
}));

// ===========================|| SIDEBAR DRAWER ||=========================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout, user } = useAuth();
    const customization = useSelector((state) => state.customization);
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const appversion = `${config.appVersion}`;

    const handleLogout = async () => {
        try {
            await logout();
            setTimeout(() => {
                navigate('/', { replace: true });
            }, 1000);
        } catch (err) {
            console.error(err);
        }
    };

    const drawer = (
        <>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <div className={classes.boxContainer}>
                    <LogoSection />
                </div>
            </Box>
            <BrowserView>
                <PerfectScrollbar component="div" className={classes.ScrollHeight}>
                    <MenuList />
                    {/* <MenuCard /> */}
                    <Button
                        // sx={{ marginX: 1, display: 'block' }}
                        fullWidth
                        color="error"
                        variant="outlined"
                        onClick={handleLogout}
                        startIcon={<IconLogout stroke={1.5} size="1.3rem" color="tomato" />}
                    >
                        लॉग-आऊट
                    </Button>
                    <Box sx={{ height: '10px' }} />
                    <Chip style={{ fontFamily: 'sans', fontSize: '10px' }} size="small" label={appversion} sx={{ mr: 1 }} color="warning" />
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <MenuList />
                    {/* <MenuCard /> */}
                    <Button
                        // sx={{ marginX: 1, display: 'block' }}
                        fullWidth
                        color="error"
                        variant="outlined"
                        onClick={handleLogout}
                        startIcon={<IconLogout stroke={1.5} size="1.3rem" color="tomato" />}
                    >
                        लॉग-आऊट
                    </Button>
                    <Box sx={{ height: '10px' }} />
                    <Chip style={{ fontFamily: 'sans', fontSize: '10px' }} size="small" label={appversion} sx={{ mr: 1 }} color="warning" />
                </Box>
            </MobileView>
            {/* <ListItemButton className={classes.listItem} sx={{ borderRadius: `${customization.borderRadius}px` }} onClick={handleLogout}>
                <ListItemIcon>
                    <IconLogout stroke={1.5} size="1.3rem" color="tomato" />
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Typography variant="body2" color="error">
                            लॉग-आऊट
                        </Typography>
                    }
                />
            </ListItemButton> */}
        </>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <nav className={classes.drawer} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                classes={{
                    paper: classes.drawerPaper
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </nav>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
